import { httpUrl } from 'utils/story-sponsor';
import styles from 'styles/modules/newsAlert/Newsroom.module.scss';

// The phone layout is the base style, so "mobile" adds no class.
const VARIANT = {
    desktop: styles.bannerDesktop,
    mobile: '',
};

const NewTab = () => (
    <span className={styles.visuallyHidden}> (opens in a new tab)</span>
);

// Past this many characters a name could wrap at the full size, so it drops a size instead.
const LONG_NAME = 16;

// Real HTML, not an image. The admin preview forces a variant and is not a link.
export const SponsorBanner = ({ sponsor, variant, asPreview }) => {
    const href = httpUrl(sponsor.url);
    const logo = httpUrl(sponsor.logoUrl);
    const className = [
        styles.banner,
        VARIANT[variant] ?? styles.bannerAuto,
    ].join(' ');
    const content = (
        <>
            <span
                className={[
                    styles.bannerLogo,
                    sponsor.logoBg === 'white' ? styles.bannerLogoWhite : '',
                ].join(' ')}
            >
                {logo && <img src={logo} alt={sponsor.name} />}
            </span>
            <span className={styles.bannerId}>
                <span className={styles.bannerKind}>{sponsor.label}</span>
                <span
                    className={[
                        styles.bannerName,
                        sponsor.name?.length > LONG_NAME
                            ? styles.bannerNameLong
                            : '',
                    ].join(' ')}
                >
                    {sponsor.name}
                </span>
            </span>
            <span className={styles.bannerExpertise}>
                <span className={styles.bannerExperts}>Experts in:</span>
                <span className={styles.bannerSpecialisms}>
                    <span className={styles.bannerSpecialismList}>
                        {sponsor.specialisms.map((specialism, i) => (
                            <span key={i}>{specialism}</span>
                        ))}
                    </span>
                </span>
            </span>
        </>
    );

    if (asPreview || !href) {
        return <div className={className}>{content}</div>;
    }
    return (
        <a
            className={className}
            href={href}
            target="_blank"
            rel="sponsored nofollow noopener"
        >
            {content}
            <NewTab />
        </a>
    );
};

// One ad per page, labelled, at a fixed size so nothing shifts as it loads.
const StorySponsor = ({ sponsor }) => {
    if (!sponsor.imageUrl) {
        return (
            <aside
                className={styles.storySponsor}
                aria-label="Advertisement"
                data-nosnippet
            >
                <div className={styles.storySponsorFrame}>
                    <span className={styles.storySponsorLabel}>
                        Advertisement
                    </span>
                    <SponsorBanner sponsor={sponsor} />
                </div>
            </aside>
        );
    }
    const href = httpUrl(sponsor.url);
    const src = httpUrl(sponsor.imageUrl);
    if (!href || !src) return null;
    return (
        <aside
            className={styles.storySponsor}
            aria-label="Advertisement"
            data-nosnippet
        >
            <span className={styles.storySponsorLabel}>Advertisement</span>
            <a href={href} target="_blank" rel="sponsored nofollow noopener">
                <img
                    className={styles.storySponsorImage}
                    src={src}
                    alt={`Advertisement: ${sponsor.name}`}
                    width={728}
                    height={90}
                />
                <NewTab />
            </a>
        </aside>
    );
};

export default StorySponsor;
